import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import { useSnackbar } from 'notistack';
import ChannelForm from '../../../components/ChannelForm';
import FormDrawer from '@afosto/app-components-react/FormDrawer';
import { channels as channelsApi } from '@afosto/catalog/api/Channels';
import translations from './translations';

const FIXED_CLIENT_IDS = {
  pos: '1ccad8a204d7768d9672340fb64589c13cb5c2169201901108ece6ce064d',
  order: '95a2d0280c1737b9c00f9e0c4d77aa10c3c38828163f51eeab7c8090b7bb',
};

const CreateChannelDrawer = ({ isOpen, onClose, onCreate }) => {
  const intl = useIntl();
  const { enqueueSnackbar } = useSnackbar();

  const handleCreateChannel = async ({ client, description, name, type }) => {
    try {
      const response = await channelsApi.createChannel({
        client_id: FIXED_CLIENT_IDS[type] ?? client?.client_id,
        description,
        name,
        type,
      });
      const { data } = response ?? {};

      enqueueSnackbar(intl.formatMessage(translations.feedback.channelCreated), {
        variant: 'success',
      });

      if (onCreate && typeof onCreate === 'function') {
        onCreate(data);
      }
    } catch (err) {
      enqueueSnackbar(intl.formatMessage(translations.feedback.channelNotCreated), {
        variant: 'error',
      });
    }
  };

  return (
    <FormDrawer
      title={intl.formatMessage(translations.title)}
      isOpen={isOpen}
      onClose={onClose}
      drawerWidth="400px"
    >
      <ChannelForm onCancel={onClose} onSubmit={handleCreateChannel} />
    </FormDrawer>
  );
};

CreateChannelDrawer.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onCreate: PropTypes.func,
};

CreateChannelDrawer.defaultProps = {
  isOpen: false,
  onClose: undefined,
  onCreate: undefined,
};

export default CreateChannelDrawer;
